export const SUBSCRIPTION_TYPE_RESTRICTED = "restricted";
export const SUBSCRIPTION_TYPE_UNCHARGEABLE = "unchargeable";
